module.exports = __webpack_public_path__ + "media/img/favicon/browserconfig-6b8dc7ce6b7692eaf9756102014eda77.xml";